export class AppDTO {
    version:string;
    groupId:string;
    artifactId:string;
}